import {CollectionInfoModel, CollectionType} from '../../api/types.ts';
import React, {useState} from 'react';
import MixCard from '../projects/MixCard.tsx';
import SelectProjectModal from '../projects/SelectProjectModal.tsx';
import {Button} from 'reactstrap';

interface GroupHomeProjectProps {
    collection: CollectionInfoModel;
    onHomeProjectChanged: (mixId: string | null) => void;
    myProjects?: boolean;
}

const GroupHomeProject: React.FC<GroupHomeProjectProps> = ({
    collection,
    onHomeProjectChanged,
    myProjects
}) => {
    const [showSelectProjectModel, setShowSelectProjectModel] = useState(false);
    // A person's portfolio is a User collection, so it isn't a "group" to them.
    const label =
        collection.collectionType === CollectionType.User
            ? 'Home project'
            : 'Group home project';

    return (
        <div className="mb-3">
            <label htmlFor="HomeMixId" className="form-label">
                {label}
            </label>

            {collection.homeMixId && (
                <div className="mx-gallery">
                    <MixCard
                        mixId={collection.homeMixId}
                        onRemove={() => onHomeProjectChanged(null)}
                    />
                </div>
            )}

            {showSelectProjectModel && (
                <SelectProjectModal
                    onClose={() => setShowSelectProjectModel(false)}
                    onProjectSelected={mix => {
                        onHomeProjectChanged(mix.id!);
                        setShowSelectProjectModel(false);
                    }}
                    myProjects={myProjects}
                />
            )}
            <div className="d-flex justify-content-end">
                <Button
                    color="primary"
                    onClick={() => setShowSelectProjectModel(true)}
                >
                    Set {label.toLowerCase()}
                </Button>
            </div>
        </div>
    );
};

export default GroupHomeProject;
